import React, { useState, useEffect, useContext } from 'react';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import { API } from '../../../API/API';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { UserContext } from '../../../context/UserContext';

const SchoolReport = (props) => {

    const { userInfo } = useContext(UserContext);

    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);
    const [gridFilter, setGridFilter] = useState([]);

    const [columns] = useState([
        {
            name: 'Код',
            fieldName: 'empcode',
            colSize: 'mid'
        },
        {
            name: 'Ажилтны нэр',
            fieldName: 'empfirstname',
            colSize: 'mid'
        }, {
            name: 'Эцэг/эх-ийн нэр',
            fieldName: 'emplastname',
            colSize: 'mid'
        },
        {
            name: 'Албан байгууллага',
            fieldName: 'companyname',
            colSize: 'mid'
        },
        {
            name: 'Дотоод нэгж',
            fieldName: 'departmentname'
        },
        {
            name: 'Ажлын байр',
            fieldName: 'positionname',
            colSize: 'mid'
        },
        {
            name: 'Сургууль',
            fieldName: 'universityname',
            minColSize: 'mid'
        },
        {
            name: 'Төгссөн улс',
            fieldName: 'countryname'
        },
        {
            name: 'Аймаг, хот',
            fieldName: 'divisionname'
        },
        {
            name: 'Элссэн огноо',
            fieldName: 'fromdate'
        },
        {
            name: 'Төгссөн огноо',
            fieldName: 'todate'
        },
        {
            name: 'Мэргэжил',
            fieldName: 'professionname'
        },
        {
            name: 'Боловсролын түвшин',
            fieldName: 'educationlevelname'
        },
        {
            name: 'Голч дүн',
            fieldName: 'gpa'
        },
        {
            name: 'Голч дүн /хувиар/',
            fieldName: 'gpapercent'
        },
        {
            name: 'Хүйс',
            fieldName: 'empgendername'
        }
    ]);

    const [loading, setLoading] = useState(false);

    const getData = async (p_gridfilter) => {
        setLoading(true);
        let tData = [];

        let filtercolumns = [];
        if (p_gridfilter?.length > 0) {
            filtercolumns = p_gridfilter;
        }

        if (props.company) {
            filtercolumns.push({
                "fieldname": "companyid",
                "value": userInfo.companyid
            });
        }

        await API.post('/api/humanresource/report/get_emp_education_report', filtercolumns).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tData = response.data.retdata;
            }
        });

        setData(tData);
        setOData(tData);
        setLoading(false);
    };


    const getGridFilterData = async () => {
        let tGridFilter = [];
        await API.get('/api/humanresource/report/get_emp_education_report_filter_data').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                if (response.data?.retdata?.length > 0) {
                    tGridFilter = response.data.retdata;
                }
            }
        });
        setGridFilter(tGridFilter);
    }

    useEffect(() => {
        getData();
        getGridFilterData();
    }, []);

    const onSearch = (p_data) => {
        setData(p_data);
    }

    const onGridFilterChange = async (p_gridfiltervalue) => {
        getData(p_gridfiltervalue);
    }

    return (
        <div>
            <PageHeader
                title='Сургууль'
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                gridFilter={gridFilter}
                dataCount={data.length}
                onGridFilterChange={onGridFilterChange}
                loading={loading}
            />
            <GridDefaultShimmer
                data={data}
                columns={columns}
                loading={loading}
            />
        </div>
    );
}

export default SchoolReport;